import Image from '@/components/ui/Image';

/**
 * Removable active-filter pill — rounded chip with an accessible "×" remove
 * affordance. Shared filter-bar primitive (the transactions filter bar
 * hand-rolls the same anatomy and can migrate here).
 */
export function RemovableFilterPill({
  value,
  label,
  imageUrl,
  removeLabel,
  tone = 'neutral',
  onRemove,
}: {
  value: string;
  label: string;
  imageUrl?: string;
  removeLabel: string;
  tone?: 'neutral' | 'brand';
  onRemove: (value: string) => void;
}) {
  function handleRemove() {
    onRemove(value);
  }

  return (
    <span
      className={`flex items-center gap-1.5 rounded-full py-1 text-2xs font-semibold ${imageUrl ? 'pr-2 pl-1.5' : 'px-2'} ${
        tone === 'brand' ? 'bg-brand-50 text-brand-700' : 'bg-muted text-text-secondary'
      }`}
    >
      {imageUrl && (
        <Image src={imageUrl} alt="" width={12} height={12} className="size-3 shrink-0 rounded-full" />
      )}
      {label}
      <button type="button" aria-label={removeLabel} onClick={handleRemove} className="transition-colors hover:text-error">×</button>
    </span>
  );
}
